module.exports = __webpack_public_path__ + "img/cartas-para-cantar-silabas-directas.be27b7dc.png";